<template>
    <div class="Card TableCountsCard">
        <div v-for="(value, label) in values" :key="label">
            <div>{{ label }}</div>
            <Counter :value="value" />
        </div>
    </div>
</template>

<script>
import Counter from '@/components/Counter';

export default {
    components: {
        Counter,
    },

    props: {
        values: {
            required: true,
        },
    },
}
</script>
